import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { RequestBwt } from "../../../models/request/request-bwt";
import { DevicesService } from "../../../services/devices.service";
import { RequestDeviceWarehouseRefillDto } from "../../../models/request/request-device-warehouse-refills";
import { GridComponent } from "@progress/kendo-angular-grid";
import { DeviceStatus } from "../../../enums";

@Component({
	selector: 'request-page-warehouse-replenishment',
	templateUrl: './request-page-warehouse-replenishment.component.html',
    styleUrls: ['./request-page-warehouse-replenishment.component.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	],
	encapsulation: ViewEncapsulation.None,
})
export class RequestPageWarehouseReplenishmentComponent implements OnInit {

    @ViewChild("requestDevicesGrid") requestDevicesGrid: GridComponent;

    public rowClass() {
		return {
			'cursor-pointer': true
		};
	}

    @Input() request: RequestBwt;

	public loading: boolean = false;

    requestDevices: RequestDeviceWarehouseRefillDto[] = []

    constructor(
        private devicesService: DevicesService
    ) { }

    ngOnInit(): void {
		this.loading = true;
        this.devicesService.getDevicesForReplenishment(this.request.requestId).subscribe((response) => {
			this.requestDevices = response;
			this.loading = false;
		});
    }

	getColorByDeviceStatus(device: RequestDeviceWarehouseRefillDto): string {
		switch (device.deviceStatusId)
		{
			case <number>DeviceStatus.issued: return '#70c642ff';
			case <number>DeviceStatus.partiallyIssued: return '#c69a42ff';
			case <number>DeviceStatus.inRequest: return '#ca416fff';
			default: return '#ffffff';
		}
	}
}